import { render } from "./IconifyIcon.vue?vue&type=template&id=2d8c7978"
import script from "./IconifyIcon.vue?vue&type=script&lang=js"
export * from "./IconifyIcon.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__